import { colors, fontSizes } from '_/config/theme';

import { useVisit } from '_/hooks/VisitContext';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View, TouchableOpacity } from 'react-native';

import ModalView from '../Modal';
import Text from '../Text';
import { cpf } from 'cpf-cnpj-validator';

interface MeetingDetailsModalProps {
  hideModalMeeting(isMeetingConfirmed?: boolean): void;
  handleConfirm(): void;
  isModalVisible: boolean;
}

const MeetingDetailsModal: React.FC<MeetingDetailsModalProps> = ({
  hideModalMeeting,
  handleConfirm,
  isModalVisible,
}) => {
  const { t, i18n } = useTranslation();
  const { visit } = useVisit();

  return (
    <ModalView isVisible={isModalVisible}>
      <Text size={fontSizes.xl} center fontType="bold">
        {t('meetingView.meetingDetails')}
      </Text>
      <View style={styles.content}>
        <View style={styles.col}>
          <Text fontType="semibold" style={styles.textStrong}>
            {t('Name')}:
          </Text>
          <Text style={styles.text}>{visit.name}</Text>
        </View>
        <View style={styles.col}>
          <Text fontType="semibold" style={styles.textStrong}>
            {t('Company')}:
          </Text>
          <Text style={styles.text}>{visit.meeting?.title}</Text>
        </View>
        {visit?.cpf && (
          <View style={styles.col}>
            <Text fontType="semibold" style={styles.textStrong}>
              {t('Cpf')}:
            </Text>
            <Text style={styles.text}>{cpf.format(visit?.cpf)}</Text>
          </View>
        )}
        {
          !!visit.customFields?.map((cf) => (
            <View style={styles.col}>
              <Text fontType="semibold" style={styles.textStrong}>
                {cf?.localizedName?.[i18n.language] ?? cf.name}:
              </Text>
              <Text style={styles.text}> {cf?.localizedValue?.[i18n.language] ?? cf.value}:</Text>
            </View>
          ))
        }
      </View>
      <View style={styles.buttonContanier}>
        <TouchableOpacity style={styles.button} onPress={() => hideModalMeeting(false)}>
          <Text fontType="semibold" size={24} color={colors.dark3}>
            {t('Cancel')}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity style={styles.button} onPress={handleConfirm}>
          <Text fontType="semibold" size={24} color={colors.dark3}>
            {t('Confirm')}
          </Text>
        </TouchableOpacity>
      </View>
    </ModalView>
  );
};

export default MeetingDetailsModal;

const styles = StyleSheet.create({
  content: {
    width: '100%',
    paddingBottom: 24,
    paddingHorizontal: 24,
    borderBottomWidth: 1,
    borderBottomColor: colors.light3,
    overflow: 'hidden',
  },
  col: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12,
  },
  infoButtonTag: {
    marginTop: 4,
    marginLeft: 8,
    paddingHorizontal: 8,
    paddingVertical: 2,
    borderRadius: 4,
    borderWidth: 1,
    borderColor: colors.light3,
  },
  textStrong: {
    fontSize: fontSizes.lg2,
  },
  text: {
    fontSize: fontSizes.xl,
    marginLeft: 8,
  },
  buttonContanier: {
    flexDirection: 'row',
    justifyContent: 'space-evenly',
    marginTop: 12,
    width: '100%',
  },
  button: {
    alignItems: 'center',
    justifyContent: 'center',
    marginTop: 12,
  },
});
